import { User } from './model/user/userSlice.ts';

export function userHasRole(user: User | null, requiredRoles: string | [string] | undefined) {
    return hasRole(user?.roles ?? null, requiredRoles);
}

function hasRole(userRoles: Array<string> | null, requiredRoles: string | [string] | undefined) {
    if (userRoles == null || userRoles.length === 0) {
        return false;
    }

    if (requiredRoles === undefined) {
        return true;
    }

    const rolesToCheck = (typeof requiredRoles === 'string') ? [requiredRoles] : requiredRoles;

    if (rolesToCheck.length == 0) {
        return true;
    }

    return rolesToCheck.every(role => userRoles.includes(role));
}